import { Route, Navigate } from "react-router-dom";
import Index from "@/pages/Index";
import Portfolios from "@/pages/Portfolios";
import About from "@/pages/About";
import Team from "@/pages/Team";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Podcast from "@/pages/Podcast";
import YearEndReview2025 from "@/pages/YearEndReview2025";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Unsubscribe from "@/pages/Unsubscribe";
import AWMGroup from "@/pages/AWMGroup";
import NotFound from "@/pages/NotFound";
import PRange from "@/pages/portfolios/P";
import RRange from "@/pages/portfolios/R";
import DistRange from "@/pages/portfolios/Dist";
import IntegrityRange from "@/pages/portfolios/Integrity";
import P1Portfolio from "@/pages/portfolios/P1";
import P2Portfolio from "@/pages/portfolios/P2";
import P3Portfolio from "@/pages/portfolios/P3";
import P4Portfolio from "@/pages/portfolios/P4";
import P5Portfolio from "@/pages/portfolios/P5";
import R1Portfolio from "@/pages/portfolios/R1";
import R2Portfolio from "@/pages/portfolios/R2";
import R3Portfolio from "@/pages/portfolios/R3";
import R4Portfolio from "@/pages/portfolios/R4";
import R5Portfolio from "@/pages/portfolios/R5";
import DistLowPortfolio from "@/pages/portfolios/DistLow";
import DistMediumPortfolio from "@/pages/portfolios/DistMedium";
import DistHighPortfolio from "@/pages/portfolios/DistHigh";
import TeamMember1 from "@/pages/team/MarkInsley";
import TeamMember2 from "@/pages/team/SamHallett";
import TeamMemberProfile from "@/pages/team/TeamMemberProfile";

// Shared PUBLIC marketing routes — the surfaces every audience (internal, adviser, public) may see.
// These are the routes that live inside the `<Layout>`-wrapped `/*` catch-all block in the original
// App.tsx. Returned as a route fragment (a function, not JSX) so each entry composes it into its own
// nested <Routes> without copy/paste drift. NOTE: the trailing `*` NotFound is included here; the
// caller must place this fragment LAST inside its <Routes>. `/insights*` is intentionally NOT here —
// it is auth-gated and lives in insightsRoutes.tsx (internal + adviser only).
export function publicRoutes() {
  return (
    <>
      <Route path="/" element={<Index />} />
      <Route path="/services" element={<Navigate to="/portfolios" replace />} />
      <Route path="/portfolios" element={<Portfolios />} />
      <Route path="/portfolios/p" element={<PRange />} />
      <Route path="/portfolios/p1" element={<P1Portfolio />} />
      <Route path="/portfolios/p2" element={<P2Portfolio />} />
      <Route path="/portfolios/p3" element={<P3Portfolio />} />
      <Route path="/portfolios/p4" element={<P4Portfolio />} />
      <Route path="/portfolios/p5" element={<P5Portfolio />} />
      <Route path="/portfolios/r" element={<RRange />} />
      <Route path="/portfolios/r1" element={<R1Portfolio />} />
      <Route path="/portfolios/r2" element={<R2Portfolio />} />
      <Route path="/portfolios/r3" element={<R3Portfolio />} />
      <Route path="/portfolios/r4" element={<R4Portfolio />} />
      <Route path="/portfolios/r5" element={<R5Portfolio />} />
      <Route path="/portfolios/dist" element={<DistRange />} />
      <Route path="/portfolios/dist-low" element={<DistLowPortfolio />} />
      <Route path="/portfolios/dist-medium" element={<DistMediumPortfolio />} />
      <Route path="/portfolios/dist-high" element={<DistHighPortfolio />} />
      <Route path="/portfolios/integrity" element={<IntegrityRange />} />
      <Route path="/about" element={<About />} />
      <Route path="/team" element={<Team />} />
      {/* Two hand-built profiles keep their bespoke pages; static segments outrank :slug in React
          Router v6, so these always win regardless of order. */}
      <Route path="/team/mark-insley" element={<TeamMember1 />} />
      <Route path="/team/sam-hallett" element={<TeamMember2 />} />
      {/* Everyone else renders from their team_members row. Team.tsx links every active member, so
          without this the rest of the team 404'd on the public site. Data-driven, so adding a member
          or filling in their bio/photo updates the site with no code change. */}
      <Route path="/team/:slug" element={<TeamMemberProfile />} />
      <Route path="/awm-group" element={<AWMGroup />} />
      <Route path="/blog" element={<Blog />} />
      {/* The Categories sidebar on /blog has always linked to /blog/category/<slug>, but no such
          route existed, so all 16 category buttons 404'd. Static segments outrank the :slug param
          in React Router v6, so this cannot be swallowed by /blog/:slug regardless of order. */}
      <Route path="/blog/category/:category" element={<Blog />} />
      {/* Hand-built marketing page (not a blog_posts row). It previously lived in the INTERNAL-only
          partnerOpsRoutes fragment purely because of where it sat in the old monolithic App.tsx —
          which meant the public /blog banner linking to it fell through to /blog/:slug and rendered
          "Article Not Found" in the adviser and public bundles. It is ungated marketing content, so
          it belongs here. No <Layout> wrapper: publicRoutes is composed inside <Layout> by
          AppInternal and <PublicLayout> by AppPublic, so wrapping again would double-wrap. */}
      <Route path="/blog/year-end-review-2025" element={<YearEndReview2025 />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      {/* Public "Capital & Context" podcast page. Ungated marketing content — the episodes are
          already public on YouTube and Spotify — so it belongs in this shared fragment and ships
          in all three bundles. Reads the anon-callable fetch-media-feeds edge function rather
          than the podcast_episodes table, which is authenticated-only. */}
      <Route path="/podcast" element={<Podcast />} />
      {/* Policy Centre routes handled at top-level with Layout wrapper */}
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/unsubscribe" element={<Unsubscribe />} />
      <Route path="*" element={<NotFound />} />
    </>
  );
}
